// import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import "./HostSlider.css"; // Custom styles

// Sample Data
const hosts = [
    {
        id: 1,
        name: "Dondila Marcos",
        location: "Hosting in New York since 2015",
        description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        image: "https://t4.ftcdn.net/jpg/07/57/59/25/360_F_757592568_v96NBkRahyTl9QFa99qpcmePYnfoXwZq.jpg",
    },
    {
        id: 2,
        name: "Sarah Johnson",
        location: "Hosting in Los Angeles since 2018",
        description:
            "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
        image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS7t3xKQbbZSjGz-eoEc0fOUFAk4Q9XjeUhjw&s",
    },
    {
        id: 3,
        name: "James Peterson",
        location: "Hosting in Chicago since 2020",
        description:
            "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
        image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTIXByuQH568NtoO708VOCbJWw4848mZDqE7DbrIbMezw08rn6X0HXJLeCfcUUkFO7jdvw&usqp=CAU",
    },
];

const HostContainer = () => {
    return (
        <div className="host-slider-container">
        <div className="container">
            <h2 className="slider-title fw-bold">Earn money as a Host</h2>
            <Swiper
                spaceBetween={30}
                slidesPerView={1}
                navigation={{
                    nextEl: ".next-arrow",
                    prevEl: ".prev-arrow",
                }}
                pagination={{ clickable: true }}
                loop={true}
                autoplay={{ delay: 3000 }}
                modules={[Navigation, Pagination, Autoplay]}
                className="host-swiper"
            >
                {hosts.map((host) => (
                    <SwiperSlide key={host.id}>
                        <div className="host-slide">
                            {/* Left Side: Image */}
                            <div className="d-flex flex-column align-items-center">
                                <div className="host-image-container">
                                    <img src={host.image} alt={host.name} className="host-image" />
                                </div>
                                <div className="slider-navigation">
                                    <button className="prev-arrow">
                                        <FaArrowLeft />
                                    </button>
                                    <span className="slider-counter">03 — 85</span>
                                    <button className="next-arrow">
                                        <FaArrowRight />
                                    </button>
                                </div>
                            </div>
    
                            {/* Right Side: Text Content */}
                            <div className="host-text">
                                <p className="host-description">{host.description}</p>
                                <h4 className="host-name">{host.name}</h4>
                                <p className="host-location">{host.location}</p>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    
        {/* ✅ Right Side Background Cut-Out Image */}
        <div className="right-cutout-image">
            <img src={require("../Assests/crop1.png")} alt="Host Cutout" />
        </div>
    </div>
    
    );
};

export default HostContainer;
